module.exports = {
  logo: {
    src: 'logo.svg',
    height: 50, 
  },
  loginBackground: 'login-background.jpg',
};
